export default __webpack_public_path__ + "static/media/TJ.3adf4542.svg";